// extracted by mini-css-extract-plugin
export default {"container":"VisaoGeralElasticidade_container__GH8gV","loadingWrapper":"VisaoGeralElasticidade_loadingWrapper__lhQfo"};